import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Formula } from '../models';
import { Autocolor } from '../models/autocolor';
import { FormulaColor } from '../models/formulacolor';
import { Subformula } from '../models/subformula';
import { FormulaService } from '../services';
import { FormulaColorService } from '../services/formulacolor.service';

@Component({
  selector: 'formulas-color',
  templateUrl: './formulas-color.component.html',
  styleUrls: ['./formulas-color.component.css']
})
export class FormulasColorComponent implements OnInit {

  autocolor: Autocolor;
  formula: Formula;
  formulacolor: FormulaColor;
  subformulas: Subformula[];
  errorMessage: string;
  isLoading: boolean;

  collapsed: boolean = false;

  constructor(
    private formulaService: FormulaService,
    private formulacolorService: FormulaColorService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.collapsed = false
    this.isLoading = true;
    this.getDatos();

  }

  getDatos(): void {
    const idsistema = + this.route.snapshot.paramMap.get('idsistema');
    const idformula = this.route.snapshot.paramMap.get('idformula');
    const idcolor = + this.route.snapshot.paramMap.get('idcolor');

    this.formulaService.getAutocolor(idcolor)
      .subscribe(ac => this.autocolor = ac);

    this.formulaService.getFormulaColorById(idsistema, idformula, idcolor)
      .subscribe(fc => {
        this.formulacolor = fc;
        this.formula = fc.formula;

        this.formulaService.getSubformulas( this.formulacolor.formula.pk.idsistema, this.formulacolor.formula.pk.id).subscribe(
          sub => {
            this.subformulas = sub;
            this.formula.subformulas = sub;
          }
        )
        this.isLoading = false;
      });

  }


  imprimirFormula(): any {
    this.formulaService.prepararFormula(this.formulacolor)
      .subscribe(
        idPreparacion => {
          //impresión
          this.formulacolorService.imprimirPreparacion(idPreparacion).subscribe(
            (res) => {
              const fileURL = URL.createObjectURL(res);
              window.open(fileURL, '_blank');
            }
          );
        });
  }
  goBack(): void {
    this.location.back();
  }

}
